import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './context';
import { AuthLoading } from './AuthLoading';

/**
 * Route guard. While the on-mount session probe is in flight (`probing`) it
 * renders a neutral loading state and does NOT redirect — this is what keeps a
 * refresh/deep-link from bouncing an authenticated user to /sign-in. Once the
 * probe resolves, an unauthenticated user is redirected to /sign-in with
 * `sessionExpired` so the sign-in screen can announce why.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === 'probing') {
    return <AuthLoading />;
  }
  if (status !== 'authenticated') {
    return <Navigate to="/sign-in" replace state={{ sessionExpired: status !== 'unknown' }} />;
  }
  return <>{children}</>;
}
